/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import classNames from "classnames";

/**
 * Internal dependencies
 */
import BaseTopbar from "layout/topbar";

/**
 * Style dependencies
 */
import "./topbar.scss";

const Topbar = ({ children }) => {
  const classes = classNames("topbar", "report-builder__topbar");

  return (
    <Box className="header">
      <Box className={classes} padding="xlarge">
        <Box className={`report-builde__topbar-menu`}>
          <Box
            justifyContent="spaceBetween"
            alignItems="center"
            display="flex"
            width="full"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Topbar;
